<script lang="ts">
    import { onMount, onDestroy } from "svelte";
    import { cn } from "../cn";

    export let align: "start" | "end" = "end";
    let className = "";
    export { className as class };

    let open = false;
    let containerEl: HTMLDivElement;

    function toggle() {
        open = !open;
    }
    function closeIfOutside(e: MouseEvent) {
        if (containerEl && !containerEl.contains(e.target as Node)) open = false;
    }
    function handleEsc(e: KeyboardEvent) {
        if (e.key === "Escape") open = false;
    }

    onMount(() => {
        document.addEventListener("mousedown", closeIfOutside);
        document.addEventListener("keydown", handleEsc);
    });
    onDestroy(() => {
        document.removeEventListener("mousedown", closeIfOutside);
        document.removeEventListener("keydown", handleEsc);
    });
</script>

<div class="relative inline-block" bind:this={containerEl}>
    <span on:click={toggle} class="inline-block">
        <slot name="trigger" />
    </span>

    {#if open}
        <div
            class={cn(
                "absolute z-50 mt-2 w-72 rounded-xl border border-[var(--border)] bg-[var(--popover)] text-[var(--popover-foreground)] shadow-2xl shadow-black/40 p-4 animate-in fade-in-0 zoom-in-95 duration-100",
                align === "end" ? "right-0" : "left-0",
                className,
            )}
        >
            <slot {open} />
        </div>
    {/if}
</div>
